import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { trackPageview, gaPageview } from "../../lib/analytics";

export const Layout = () => {
  const { pathname } = useLocation();
  const lastPath = useRef(null);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    if (lastPath.current === pathname) return; // dedupe StrictMode double-effect
    lastPath.current = pathname;
    trackPageview(pathname);
    const t = setTimeout(() => gaPageview(pathname), 300);
    return () => clearTimeout(t);
  }, [pathname]);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App">
        <div className="noise" />
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
};
